export const allNavigationMenu = [
  {
    key: "shop",
    label: "Shop",
    name: "shop",
    path: "/",
  },
  {
    key: "cart",
    label: "Cart",
    name: "cart",
    path: "/cart",
  },
  {
    key: "orders",
    label: "Orders",
    name: "orders",
    path: "/orders",
    authOnly: true,
  },
  {
    key: "account",
    label: "Account",
    name: "account",
    path: "/accounts",
    authOnly: true,
  },
  {
    key: "products",
    label: "Products",
    name: "products",
    path: "/admin/products",
    adminOnly: true,
  },
  {
    key: "admin-orders",
    label: "All orders",
    name: "admin-orders",
    path: "/admin/orders",
    storeOnly: true,
  },
  {
    key: "users",
    label: "Users",
    name: "users",
    path: "/users",
    adminOnly: true,
  },
  {
    key: "api-keys",
    label: "API keys",
    name: "api-keys",
    path: "/api-keys",
    adminOnly: true,
  },
];
